<template>
  <div style="border:1px solid #ccc;box-shadow:2px 1px 1px #ccc;">
    <div class="tit">{{navList.title}}</div>
    <ul>
      <li
        v-for="(item,index) in navList.list"
        :key="index"
        @click="to_news_page(item)"
      >{{item.name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    navList: {
      type: Object,
      default: {}
    }
  },
  methods: {
    to_news_page(options) {
      if (!options.href) {
        this.$router.push({
          name: options.route,
          params: {
            type_id: options.type_id
          }
        });
      }else{
        window.open(options.href)
      }
    }
  }
};
</script>

<style scoped>
.tit {
  background: #ccc;
  color: #333;
  text-align: center;
  padding: 5px 0;
}
ul > li {
  text-align: center;
  padding: 5px 0;
}
ul > li:hover {
  cursor: pointer;
  background: #0098fb;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/link.vue


// WEBPACK FOOTER //
// src/pages/home/link.vue